module.exports = __webpack_public_path__ + "static/img/67-3.e692c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/67-3.jpg
// module id = 2tFM
// module chunks = 0